const env = {
  baseUrl: process.env.BASE_URL,
  dataRefreshIntervalInSeconds: parseInt(process.env.VUE_APP_DATA_REFRESH_INTERVAL || "30"),
  watchersLimit: parseInt(process.env.VUE_APP_WATCHERS_LIMIT || "4"),
  buildNumber: process.env.VUE_APP_BUILD_NUMBER,
  buildDate: process.env.VUE_APP_BUILD_DATE,

  // This is being injected as part of the deployment process. If changing the name, also update the powershell script
  appInsightsInstrumentationKey: process.env.VUE_APP_APP_INSIGHTS_INSTRUMENTATION_KEY,

  nativeApp: {
    notificationRefreshIntervalInSeconds: parseInt(
      process.env.VUE_APP_NATIVE_APP_NOTIFICATION_REFRESH_INTERVAL || "300"
    )
  } as NativeAppConfig
};

export interface NativeAppConfig {
  notificationRefreshIntervalInSeconds: number;
}

export default env;
